import QuickViewModal from '../components/QuickViewModal';
import HFSPanels from '../components/HFSPanels';
import HFSGridFilter from '../components/HFSGridFilter';
import PlatMap from '../components/PlatMapPopup';

document.addEventListener('DOMContentLoaded', () => {
    const quickviewModal = QuickViewModal('js-quickview-modal');

    //init panels
    HFSPanels('js-hfs-panels');
    new PlatMap();
    new HFSGridFilter();
});

//window.addEventListener('load', () => {
//    //initialize map
//    initMap('js-community-map-info-window').catch(error => {
//        console.error('Failed to initialize map:', error);
//    });
//});
